import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import LoginForm from '../components/forms/LoginForm';
import { useAuth } from '../hooks/useAuth';
import { ROUTES } from '../constants';
import PoweredBy from '../components/common/PoweredBy';
import './Login.css';

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (credentials) => {
    setIsLoading(true);

    try {
      await login(credentials);
      navigate('/dashboard');
    } catch (err) {
      // Error handling is now done through error dialog popups in authService
      console.error('Login error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page" role="main" aria-label="Login page">
      <Link to={ROUTES.LANDING} className="back-button" aria-label="Back to home">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </Link>
      <div className="login-container">

        <div className="login-header">
          <div className="login-logo">
            <img
              src="/sks-icons.svg"
              alt="SKS Pvt Company Logo"
              className="login-logo-img"
              width="80"
              height="80"
            />
          </div>
          <h1>Inventory Management</h1>
          <p>Sign in to your account</p>
        </div>

        <LoginForm
          onSubmit={handleLogin}
          isLoading={isLoading}
        />

      </div>
      <PoweredBy />
    </div>
  );
};

export default Login;
